import {NgModule} from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {PageGuard} from '@core/guards/page.guard';
import {AuthGuard} from '@core/guards/auth.guard';

const routes: Routes = [
    {
        path: 'tariff',
        loadChildren: () => import('./@views/tariff/tariff.module').then((m) => m.TariffModule),
    },
    {
        path: 'page',
        canActivate: [PageGuard],
        loadChildren: () => import('./@views/pages/pages.module').then((m) => m.PagesModule),
    },
    {
        path: 'auth',
        canActivate: [AuthGuard],
        loadChildren: () => import('./@views/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'test/:id',
        loadChildren: () => import('./@views/pages/test/test.module').then((m) => m.TestModule),
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth'
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'auth'
    }
];

const config: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    // scrollOffset: [0, 100],
    useHash: true,
};


@NgModule({
    imports: [RouterModule.forRoot(routes, config)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
